export default __webpack_public_path__ + "static/media/crop-filter.706c27d0.jpg";